module.exports = __webpack_public_path__ + "inputs/img/banner3.f99d8496.png";